import { onlyNumbers } from "@/utils/reg-expressions";
import { AuxEntity } from "@/services/aux-entities.service";
import { z } from "zod";

export interface PersonDescription {
  nombre: string;
  apellido: string;
  dni: string;
  cuit: string;
}

export interface PersonaDetalle {
  id: number;
  dni: string;
  nombre: string;
  apellido: string;
  apodo: string | null;
  movil: string;
  nacimiento: string | null;
  mail: string;
  localidad: string;
  cuit: string;
  sexo?: string;
  esProductor: boolean;
  activo: boolean;
  estadoCivil: AuxEntity;
  profesion: AuxEntity;
  nivelEstudio: AuxEntity;
  hobbies: AuxEntity[];
  cuentasRelacionadas: CuentaRelacionada[];
  familiares: Familiar[];
  usuariosMobile: PDUsuarioMobile[];
  destinatarios: AgendaDestinatarios[];
}

export interface AgendaDestinatarios {
  accountNumber: string | null;
  accountType: string | null;
  alias: string | null;
  bankName: string | null;
  cbu: string | null;
  cooperativeName: string | null;
  cuit: string;
  holderName: string;
  id: number;
  moneda: string;
  type: "internal" | "external";
}

export interface CuentaRelacionada {
  id: number;
  cuenta: number;
  razonSocial: string;
  zonaComercial: string;
  cuit: string;
}

export interface Familiar {
  id: number;
  tipoRelacion: string;
  fechaCasamiento: string;
  nupcia: number;
  dni: string;
  nombre: string;
  apellido: string;
  cuit: string;
  localidad: string;
  nacimiento: string | null;
  apodo: string | null;
  sexoBiologico: string;
  estadoCivil: string;
  profesion: string;
  nivelEstudio: string;
  esProductor: boolean;
}

export interface PDUsuarioMobile {
  id: number;
  nombre: string;
  apellido: string;
  documento: string;
  cuit: string;
  mail: string;
  idAzure: string;
  movil: string;
  validaIdentidad: boolean;
  fechaCreacion: string;
  fechaModificacion: string;
  activo: boolean;
}
export const personFilterSchema = z.object({
  first_name: z.any().optional(),
  last_name: z.any().optional(),
  dni: z.any().optional(),
  cuit: z.any().optional(),
});

export const createPersonSchema = z
  .object({
    cuenta: z.any().optional(),
    agro: z.any().optional(),
    apellido: z.any().optional(),
    apodo: z.any().optional(),
    cuit: z.any().optional(),
    dni: z.any().optional(),
    estadoCivil: z.any().optional(),
    sexoBiologico: z.any().optional(),
    fecha: z.any().optional(),
    hobbies: z.array(z.any().optional()).optional(),
    localidad: z.any().optional(),
    mail: z.any().optional(),
    nivelEstudio: z.any().optional(),
    nombre: z.any().optional(),
    profesion: z.any().optional(),
    telefono: z.any().optional(),
  })
  .superRefine((data, ctx) => {
    if (!onlyNumbers.test(data?.dni)) {
      ctx.addIssue({
        code: "custom",
        path: ["dni"],
        message: "Debe ser un número válido.",
      });
    }
  });
